<template>
  <div>
    <escenario-horizontal-rehabilitacion :escenario="escenario" @change="emitirCorrecto"
                                         v-if="escenario && escenario.tipoSolucion == 'horizontal_rehabilitation'"/>

    <escenario-vertical-rehabilitacion :escenario="escenario" @change="emitirCorrecto"
                                       v-if="escenario && escenario.tipoSolucion == 'vertical_rehabilitation'"/>

    <escenario-fachada-rehabilitacion :escenario="escenario" @change="emitirCorrecto"
                                      v-if="escenario && escenario.tipoSolucion == 'facade_rehabilitation'"/>

    <escenario-horizontal :escenario="escenario" @change="emitirCorrecto"
                          v-if="escenario && escenario.tipoSolucion == 'obra_nueva_horizontal'"/>

    <escenario-vertical :escenario="escenario" @change="emitirCorrecto"
                        v-if="escenario && escenario.tipoSolucion == 'obra_nueva_vertical'"/>

    <escenario-fachada :escenario="escenario" @change="emitirCorrecto"
                       v-if="escenario && escenario.tipoSolucion == 'obra_nueva_fachada'"/>

    <escenario-urbano :escenario="escenario" @change="emitirCorrecto"
                      v-if="escenario && escenario.tipoSolucion == 'obra_nueva_urbano'"/>

    <escenario-exterior :escenario="escenario" @change="emitirCorrecto"
                        v-if="escenario && escenario.tipoSolucion == 'obra_nueva_exterior'"/>

    <escenario-exterior-rehabilitacion :escenario="escenario" @change="emitirCorrecto"
                        v-if="escenario && escenario.tipoSolucion == 'rehabilitacion_exterior'"/>
  </div>
</template>

<script>
import EscenarioHorizontal from "./EscenariosTipos/EscenarioHorizontal";
import EscenarioHorizontalRehabilitacion from "./EscenariosTipos/EscenarioHorizontalRehabilitacion";
import EscenarioVerticalRehabilitacion from "./EscenariosTipos/EscenarioVerticalRehabilitacion";
import EscenarioFachadaRehabilitacion from "./EscenariosTipos/EscenarioFachadaRehabilitacion";
import EscenarioVertical from "./EscenariosTipos/EscenarioVertical";
import EscenarioFachada from "./EscenariosTipos/EscenarioFachada";
import EscenarioUrbano from "./EscenariosTipos/EscenarioUrbano";
import EscenarioExterior from "./EscenariosTipos/EscenarioExterior";
import EscenarioExteriorRehabilitacion from "./EscenariosTipos/EscenarioExteriorRehabilitacion";

export default {
  name: "EscenarioComponente",
  model: {
    prop: 'correct',
    event: 'change'
  },
  props: {
    escenario: {type: Object, required: true},
    correct: {type: Boolean, default: false}
  },
  components: {
    EscenarioHorizontalRehabilitacion,
    EscenarioVerticalRehabilitacion,
    EscenarioFachadaRehabilitacion,
    EscenarioHorizontal,
    EscenarioVertical,
    EscenarioFachada,
    EscenarioUrbano,
    EscenarioExterior,
    EscenarioExteriorRehabilitacion
  },
  data: function () {
    return {}
  },
  methods: {
    emitirCorrecto(value) {
      this.$emit('change', value);
    },
  }
}
</script>

<style scoped>

</style>